if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }
      get mainProductForm() {
        return this.mainProductInfo?.querySelector('form[is="product-form"]') || null;
      }
      get mainSubmitButton() {
        return this.mainProductInfo?.querySelector('[id^="ProductSubmitButton-"]') || null;
      }
      get stickySellingPlanInput() {
        const form = this.productForm;
        if (!form) return null;
        let input = form.querySelector('[name="selling_plan"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        return input;
      }
      get sellingPlanId() {
        return this.stickySellingPlanInput?.value || '';
      }

      connectedCallback() {
        const forms = Array.from(document.querySelectorAll('.main-product-form'));
        const mainForm = forms.find(f => f.offsetParent !== null || f.getBoundingClientRect().height > 0) || forms[0];
        this.productFormActions = mainForm ? mainForm.querySelector('.product-form__submit') || mainForm : null;

        const infos = Array.from(document.querySelectorAll('product-info'));
        this.mainProductInfo = infos.find(i => i.offsetParent !== null || i.getBoundingClientRect().height > 0) || infos[0];
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();

        this.optionChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        if (this.mainProductInfo) {
          this.boundHandleSellingPlanUpdate = this.handleSellingPlanUpdate.bind(this);
          this.mainProductInfo.addEventListener('skio::update-selling-plan', this.boundHandleSellingPlanUpdate);
        }

        this.boundSyncBeforeSubmit = () => this.syncSellingPlanFromMainForm(false);
        this.productForm?.addEventListener('submit', this.boundSyncBeforeSubmit, { capture: true });

        this.defaultButtonText = this.productForm?.querySelector('[name="add"] span')?.textContent.trim() || FoxTheme.variantStrings.addToCart;

        this.init();
        const initialVariantId = this.querySelector(this.selectors.variantIdSelect)?.value;
        if (initialVariantId) {
          this.currentVariant = this.variantData.find((v) => v.id === Number(initialVariantId));
        }
        this.syncSellingPlanFromMainForm();

        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
          this.syncSellingPlanFromMainForm();
        });
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => { });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = !entry.isIntersecting ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 0, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.productForm;
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.defaultButtonText || FoxTheme.variantStrings.addToCart;
        }
      }

      disconnectedCallback() {
        this.optionChangeUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
        if (this.mainProductInfo && this.boundHandleSellingPlanUpdate) {
          this.mainProductInfo.removeEventListener('skio::update-selling-plan', this.boundHandleSellingPlanUpdate);
        }
        if (this.boundSyncBeforeSubmit) {
          this.productForm?.removeEventListener('submit', this.boundSyncBeforeSubmit, { capture: true });
        }
      }

      setStickyBarPrice(formattedPrice) {
        if (!formattedPrice) return;
        const containers = this.container?.querySelectorAll('.product-price-container');
        if (containers) containers.forEach((el) => { el.textContent = formattedPrice; });
      }

      formatPriceFromState() {
        const variant = this.currentVariant;
        if (!variant) return '';
        const planId = Number(this.sellingPlanId);
        const allocation = planId
          ? (variant.selling_plan_allocations || []).find((a) => a.selling_plan_id === planId)
          : null;
        return FoxTheme.Currency.formatMoney(allocation ? allocation.price : variant.price, FoxTheme.settings.moneyFormat);
      }

      updatePrice() {
        const quote = this.planQuote;
        const matchesState =
          quote &&
          (!quote.variantId || !this.currentVariant || quote.variantId === this.currentVariant.id) &&
          String(quote.sellingPlanId || '') === String(this.sellingPlanId || '');
        this.setStickyBarPrice(matchesState ? quote.formattedPrice : this.formatPriceFromState());
      }

      readMainSellingPlanId() {
        const mainForm = this.mainProductForm;
        if (!mainForm) return '';
        return new FormData(mainForm).getAll('selling_plan').filter(Boolean).pop() || '';
      }

      syncSellingPlanFromMainForm(updatePriceDisplay = true) {
        const input = this.stickySellingPlanInput;
        if (!input) return;
        input.value = this.readMainSellingPlanId();
        if (updatePriceDisplay) this.updatePrice();
      }

      handleSellingPlanUpdate(event) {
        const d = event.detail || {};
        const sellingPlanId = d.sellingPlan?.id ?? d.sellingPlanId ?? null;
        const input = this.stickySellingPlanInput;
        if (input) input.value = sellingPlanId ? String(sellingPlanId) : '';
        this.planQuote = d.formattedPrice
          ? {
              variantId: d.variant?.id ? Number(d.variant.id) : null,
              sellingPlanId: sellingPlanId ? String(sellingPlanId) : '',
              formattedPrice: d.formattedPrice,
            }
          : null;
        this.updatePrice();
      }

      handleOptionValueChange({ data: { event } }) {
        if (!this.mainProductInfo || !this.mainProductInfo.contains(event.target)) return;
        this.syncFromMainForm();
      }

      syncFromMainForm() {
        const mainSubmitButton = this.mainSubmitButton;
        if (!mainSubmitButton) return;

        const mainForm = mainSubmitButton.closest('form[is="product-form"]') || this.mainProductForm;
        if (!mainForm) return;

        const mainVariantInput = mainForm.querySelector('[name="id"]');
        const mainQuantityInput = mainForm.querySelector('[name="quantity"]');

        if (!mainVariantInput) return;

        const mainVariantId = mainVariantInput.value;
        const variantSelect = this.select;

        if (variantSelect) {
          const wasDifferent = variantSelect.value !== mainVariantId;

          this.isUpdating = true;

          variantSelect.value = mainVariantId;

          const option = variantSelect.querySelector(`option[value="${mainVariantId}"]`);
          if (option) {
            variantSelect.querySelectorAll('option').forEach(opt => opt.removeAttribute('selected'));
            option.setAttribute('selected', 'selected');
          }

          this.isUpdating = false;

          this.currentVariant = this.variantData.find((variant) => variant.id === Number(mainVariantId));

          if (wasDifferent && this.currentVariant) {
            this.updateQuantityInput();
          }
        }

        if (mainQuantityInput) {
          const stickyQuantityInput = this.productForm?.querySelector('[name="quantity"]');
          if (stickyQuantityInput && stickyQuantityInput.value !== mainQuantityInput.value) {
            stickyQuantityInput.value = mainQuantityInput.value;
          }
        }

        const isDisabled = mainSubmitButton.hasAttribute('disabled') ||
          mainSubmitButton.getAttribute('aria-disabled') === 'true';
        const isSoldOut = !mainSubmitButton.hasAttribute('name') || (this.currentVariant ? !this.currentVariant.available : true);

        this.updateButton(isDisabled || isSoldOut, isSoldOut ? FoxTheme.variantStrings.soldOut : '');
        this.syncSellingPlanFromMainForm();
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          if (!this.mainProductInfo || event.data.sectionId !== this.mainProductInfo.sectionId) return;
          this.syncFromMainForm();
        });
      }
    }
  );
}
